import { AbstractClient, CompositionClient } from "@/app/client";
import * as types from "@/app/types";
import { UUID } from "crypto";

export default class APIUserPartners extends CompositionClient {
  constructor(client: AbstractClient) {
    super(client);
  }

  getUserPartners = async (): Promise<types.PartnerResponse[]> => {
    const res = await this._fetch({
      url: `/user-partners`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  checkUserPartner = async (
    partnerId: UUID,
  ): Promise<{ is_user_partner: boolean }> => {
    const res = await this._fetch({
      url: `/user-partners/check/${partnerId}`,
      method: "GET",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  addUserPartner = async (partnerId: UUID): Promise<{ message: string }> => {
    const res = await this._fetch({
      url: `/user-partners/${partnerId}`,
      method: "POST",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  removeUserPartner = async (partnerId: UUID): Promise<{ message: string }> => {
    const res = await this._fetch({
      url: `/user-partners/${partnerId}`,
      method: "DELETE",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  toggleUserPartner = async (partnerId: UUID): Promise<{ added: boolean }> => {
    const res = await this._fetch({
      url: `/user-partners/${partnerId}/toggle`,
      method: "PUT",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };

  batchAddUserPartners = async (
    partnerIds: UUID[],
  ): Promise<{ added_count: number }> => {
    const res = await this._fetch({
      url: `/user-partners/batch/add`,
      method: "PUT",
      body: partnerIds,
      bodyMime: "application/json",
      auth: ["OAuth2PasswordBearer"],
    });
    if (res.headers.get("Content-Type") === "application/json")
      return res.json();
    throw new Error("Bad content type");
  };
}
